export interface Consents {
  ccpaSignal: boolean;
  geoRequiresSignal: boolean;
  gdprConsent: boolean;
  geoRequiresConsent: boolean;
}
